import React from 'react';

interface Props {
	title: string;
}

interface State {
	initialState: string | null;
}

export default class DocumentTitle extends React.PureComponent<Props, State> {
	state = {
		initialState: null,
	};

	componentDidMount() {
		const initialState = typeof document.title === 'string' && document.title.length > 0 ? document.title : null;

		this.setState({
			initialState,
		});
	}

	componentDidUpdate() {
		const normalizedTitle = this.state.initialState
			? `${this.props.title} | ${this.state.initialState}`
			: this.props.title;
		document.title = normalizedTitle;
	}

	componentWillUnmount() {
		const activeTitle = (document.title.split('|')[0] || '').trim();
		if (activeTitle === this.props.title) {
			document.title = this.state.initialState || '';
		}
	}

	render() {
		return null;
	}
}
